import React from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';
import { Typography } from '@packages/ui/shared';
import { PublicationForm } from '@web/vin-sessions/types';
import { State, UsePublicationFormReturnType } from './hooks/use-publication-form';
import { RichTextEditor } from './rich-text-editor';

const useStyles = createUseStyles({
    previewDescriptionStyles: {
        borderTop: `1px solid ${colors.grayThree}`,
        width: '100%',
        padding: '20px 0px 20px 0px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
});

interface Props {
    publicationInfo: PublicationForm;
    actions?: UsePublicationFormReturnType['actions'];
    state: State;
}

export const PreviewDescription = ({ publicationInfo, actions, state }: Props) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={classes.previewDescriptionStyles}>
            <Typography
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    fontSize: 21,
                    lineHeight: 32,
                    letterSpacing: 0,
                    marginBottom: 20,
                }}
            >
                {t('stisPublications:documentInfo.headers.section5', 'Preview Description')}
            </Typography>

            <RichTextEditor
                value={publicationInfo.description}
                label={t('stisPublications:documentInfo.headers.description', 'Description')}
                required
                placeholder={t('stisPublications:documentInfo.placeholder.description', 'Write Description')}
                onChange={(value) => {
                    actions?.handleDescriptionChange(value);
                }}
                errorMessage={state.descriptionErrorMessage}
            />
        </div>
    );
};
